import { render } from "./CareCard.vue?vue&type=template&id=07c6bddc&scoped=true&ts=true"
import script from "./CareCard.vue?vue&type=script&lang=ts"
export * from "./CareCard.vue?vue&type=script&lang=ts"

import "./CareCard.vue?vue&type=style&index=0&id=07c6bddc&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c6bddc"]])

export default __exports__